// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div#_pg-app{padding:0!important}.link,.st-link{cursor:pointer}.st-link{text-decoration:underline}.info-text{text-align:left;font-size:14px;color:#742a2a;background:#fed7d7;padding:5px 10px;line-height:18px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
